/** @jsxImportSource @emotion/react */
import React from 'react'
import { NewForm, NewPreview } from '../../../components/templates'
import * as styles from '../index.styles'
import Provider from '../../../context/NewContext'
import { breadcrumbItems } from '../../utils'
import { Breadcrumb } from '../../../components/atoms'

const { index, contentManagement, manageNews } = breadcrumbItems


const ManageNews: React.FC = () => {
  return (
    <Provider>
      <Breadcrumb items={[index, contentManagement, manageNews]} />
      <div css={styles.root}>
        <div css={styles.main}>
          <NewForm />
        </div>
        <div css={styles.right}>
          <NewPreview />
        </div>
      </div>
    </Provider>
  )
}

export default ManageNews
